webpackJsonp([213720915766396],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _projectImagePath = __webpack_require__(43);
	
	var _projectImagePath2 = _interopRequireDefault(_projectImagePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	  return _react2.default.createElement(
	    "main",
	    { className: "myMain" },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "\u041F\u0440\u043E\u0435\u043A\u0442\u044B"
	      ),
	      _react2.default.createElement("meta", { name: "description", content: "\u041F\u0440\u043E\u0435\u043A\u0442\u044B, \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0435 \u041E\u041E\u041E \u0425\u044D\u0434\u043C\u0435\u0439\u0434: \u0418\u0421 \u0423\u0441\u043B\u0443\u0433\u0438, \u0418\u0421 \u0413\u043E\u043B\u043E\u0441, \u0418\u0421 \u041C\u043D\u0435\u043D\u0438\u0435, \u0418\u0421 \u041C\u0435\u043C\u043E\u0440\u0438\u0430\u043B \u0438 \u0434\u0440\u0443\u0433\u0438\u0435" })
	    ),
	    _react2.default.createElement(
	      "section",
	      { className: "projects__wrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "columns" },
	          _react2.default.createElement(
	            "div",
	            { className: "projects" },
	            _react2.default.createElement(
	              "h1",
	              { className: "h1" },
	              "\u041F\u0440\u043E\u0435\u043A\u0442\u044B"
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "filters-list" },
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/html-css-sass" },
	                  "html, css, sass"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/ruby-ruby-on-rails" },
	                  "ruby, ruby-on-rails"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/javascript" },
	                  "javascript"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/angular" },
	                  "angular"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/react" },
	                  "react"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "filters-item" },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { activeClassName: "active", to: "/projects/postgres" },
	                  "postgres"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "projects__list" },
	              edges.map(function (projects) {
	                var project = projects.node.frontmatter;
	                return _react2.default.createElement(
	                  "li",
	                  { key: project.order, className: "list__item" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "columns large-6 small-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "monitor-block" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "monitor__wrapper" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "monitor desktop" },
	                          _react2.default.createElement("div", { className: "monitor__stand" }),
	                          _react2.default.createElement("div", { className: "monitor__stand-bot" }),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "monitor__img-wrapper" },
	                            _react2.default.createElement("img", { src: (0, _projectImagePath2.default)(project.desktopImg, project.path, "desktop"), alt: project.title })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "columns large-6 small-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "info" },
	                      _react2.default.createElement(
	                        "h3",
	                        { className: "info__caption" },
	                        project.title
	                      ),
	                      _react2.default.createElement(
	                        "p",
	                        { className: "info__text" },
	                        project.description
	                      ),
	                      _react2.default.createElement(
	                        "h3",
	                        { className: "item__caption" },
	                        "\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438"
	                      ),
	                      _react2.default.createElement(
	                        "ul",
	                        { className: "info__list" },
	                        project.technologies.map(function (technology, i) {
	                          return _react2.default.createElement(
	                            "li",
	                            { key: i, className: "info__item" },
	                            _react2.default.createElement(
	                              "span",
	                              null,
	                              technology
	                            )
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: project.path, className: "btn" },
	                        "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435"
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Projects;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var projectImagePath = function projectImagePath(imagePath, path, name) {
	  if (imagePath) {
	    return imagePath;
	  } else {
	    return "/images/projects" + path + name + ".png";
	  }
	};
	
	exports.default = projectImagePath;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-0ce6c4d71717a0855415.js